import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type TBeneficiaries = {
  id: number;
  traderId: number;
  actHolder: string;
  actNum: string;
  ifsc: string;
  bank: string;
  rzpCont: string;
  rzpFa: string;
  mobile: string;
  email: string;
  notes: string;
  provider: string;
  type: string;
  status: number;
  userType: string,
  accntType: string
};

type TinitialState = {
  currentSteps: number;
  tableClick: boolean;
  payoutClick: boolean;
  openBeneficiary: boolean;
  allBeneficiaries: TBeneficiaries[];
  isLoading: boolean;
  selectedBeneficiary: TBeneficiaries | null;
  filterData: TBeneficiaries[];
  openFilter: boolean;
  statusFilters: {
    status: string[];
  };
  benPayoutOtp: number;
  refId: string;
  refreshGetAll: boolean;
  addBenefiSteps: number;
};

const initialState: TinitialState = {
  currentSteps: 1,
  tableClick: false,
  payoutClick: false,
  openBeneficiary: false,
  allBeneficiaries: [],
  isLoading: false,
  selectedBeneficiary: null,
  filterData: [],
  openFilter: false,
  statusFilters: {
    status: []
  },
  benPayoutOtp: 0,
  refId: '',
  refreshGetAll: false,
  addBenefiSteps: 1
};

const beneficiarySlice = createSlice({
  name: "beneficiary",
  initialState: initialState,
  reducers: {
    setCurrentSteps: (state, action: PayloadAction<number>) => {
      state.currentSteps = action.payload;
    },
    setTableClick: (state, action: PayloadAction<boolean>) => {
      state.tableClick = action.payload;
    },
    setPayoutClick: (state, action: PayloadAction<boolean>) => {
      state.payoutClick = action.payload;
    },
    setOpenBeneficiary: (state, action: PayloadAction<boolean>) => {
      state.openBeneficiary = action.payload;
    },
    setAllBeneficiaries: (state, action: PayloadAction<TBeneficiaries[]>) => {
      state.allBeneficiaries = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setBenPayoutOtp: (state, action: PayloadAction<number>) => {
      state.benPayoutOtp = action.payload;
    },
    setSelectedBeneficiary: (state, action: PayloadAction<TBeneficiaries | null>) => {
      state.selectedBeneficiary = action.payload
    },
    setFilterData: (state, action: PayloadAction<TBeneficiaries[]>) => {
      state.filterData = action.payload
    },
    setOpenFilter: (state, action: PayloadAction<boolean>) => {
      state.openFilter = action.payload
    },
    setStatusFilters: (state, action) => {
      state.statusFilters = action.payload;
      localStorage.setItem(
        "statusFilters",
        JSON.stringify(state.statusFilters)
      );
    },
    resetStatusFilters: (state) => {
      state.statusFilters = initialState.statusFilters;
      localStorage.removeItem("statusFilters");
    },
    setRefId: (state, action: PayloadAction<string>) => {
      state.refId = action.payload
    },
    setRefreshGetAll: (state) => {
      state.refreshGetAll = !state.refreshGetAll;
    },
    setAddBenefiSteps: (state, action: PayloadAction<number>) => {
      state.addBenefiSteps = action.payload
    },
  },
});

export const {
  setCurrentSteps,
  setTableClick,
  setPayoutClick,
  setOpenBeneficiary,
  setAllBeneficiaries,
  setIsLoading,
  setSelectedBeneficiary,
  setFilterData,
  setOpenFilter,
  setStatusFilters,
  resetStatusFilters,
  setBenPayoutOtp,
  setRefId,
  setRefreshGetAll,
  setAddBenefiSteps
} =
  beneficiarySlice.actions;
export default beneficiarySlice.reducer;
